import { Pressable, StyleSheet, Text, View } from 'react-native'
import { formatGBP } from '../format'
import { colors, fontFamily, fontSize, radius, space } from '../tokens'

type Props = {
  validBands: readonly string[]
  selected: string | null
  chargeByBand?: Record<string, number>
  disabled: boolean
  onSelect: (band: string) => void
}

export const BandPillRow = ({ validBands, selected, chargeByBand, disabled, onSelect }: Props) => (
  <View style={styles.row}>
    {validBands.map((band) => {
      const isActive = selected === band
      const charge = chargeByBand?.[band]
      return (
        <Pressable
          key={band}
          accessibilityRole="button"
          accessibilityLabel={`Band ${band}${charge ? ` — ${formatGBP(charge)} a year` : ''}`}
          disabled={disabled}
          onPress={() => onSelect(band)}
          style={[styles.pill, isActive && styles.pillActive]}
        >
          <Text style={[styles.letter, isActive && styles.textActive]}>{band}</Text>
          {charge ? (
            <Text style={[styles.charge, isActive && styles.textActive]}>{formatGBP(charge)}</Text>
          ) : null}
        </Pressable>
      )
    })}
  </View>
)

const styles = StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', gap: space[8] },
  pill: {
    paddingHorizontal: space[16],
    paddingVertical: 10,
    borderRadius: radius.sm,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: colors.gray[300],
    minWidth: 64,
    minHeight: 56,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
  pillActive: {
    backgroundColor: colors.primary[100],
    borderColor: colors.primary[700],
  },
  letter: {
    fontSize: fontSize.h4,
    fontWeight: '700',
    color: colors.gray[900],
    fontFamily: fontFamily.body,
  },
  charge: {
    fontSize: fontSize.tiny,
    color: colors.gray[700],
    fontWeight: '500',
    fontFamily: fontFamily.body,
  },
  textActive: { color: colors.primary[900] },
})
